import { AccordionData } from '../../../../../../../components/Accordion/Accordion';
import { PersonStatusFieldName } from '../../../../../../../components/Forms/constants';
import { PreviewFilesList } from '../../../../../../../components/Forms/PreviewFilesList';
import { StepsNavigationName } from '../../../../../../../config/services';
import { formatDate } from '../../../../../../../helpers/dates';
import { parseFormDataValue } from '../../../../../../../helpers/parseFormDataValue';
import { NullValueGuard } from '../../../../../../../middlewares/NullValueGuard';

import { PersonStatusFormDataProps } from './types';

interface PreviewProps {
  formData: PersonStatusFormDataProps;
}

export const previewPersonStatus = ({ formData }: PreviewProps): AccordionData => {
  return {
    title: StepsNavigationName.personStatus,
    content: (
      <>
        <div className="custom-columns custom-columns_grey-bg">
          <div className="custom-columns__row custom-columns__row_padding-tiny">
            <div className="custom-columns__col">
              <div className="custom-columns__title">Назва статусу особи</div>
              <div className="custom-columns__info">
                <NullValueGuard>
                  {parseFormDataValue(formData[PersonStatusFieldName.personStatusName])?.label}
                </NullValueGuard>
              </div>
            </div>
          </div>
        </div>
        <div className="custom-columns__content-title">Дані документа, що підтверджує статус особи</div>
        <div className="custom-columns custom-columns_grey-bg custom-columns_default-gap">
          <div className="custom-columns__row custom-columns__row_padding-tiny">
            <div className="custom-columns__col">
              <div className="custom-columns__title">Тип документа, що підтверджує статус особи</div>
              <div className="custom-columns__info">
                <NullValueGuard>
                  {parseFormDataValue(formData[PersonStatusFieldName.personStatusDocType])?.label}
                </NullValueGuard>
              </div>
            </div>
            <div className="custom-columns__col">
              <div className="custom-columns__title">Серія та номер</div>
              <div className="custom-columns__info">
                <NullValueGuard>{formData[PersonStatusFieldName.personStatusDocSerialNumber]}</NullValueGuard>
              </div>
            </div>
            <div className="custom-columns__col">
              <div className="custom-columns__title">Назва організації</div>
              <div className="custom-columns__info">
                <NullValueGuard>{formData[PersonStatusFieldName.personStatusOrg]}</NullValueGuard>
              </div>
            </div>
          </div>
          <div className="custom-columns__row custom-columns__row_padding-tiny">
            <div className="custom-columns__col">
              <div className="custom-columns__title">Орган видачі</div>
              <div className="custom-columns__info">
                <NullValueGuard>{formData[PersonStatusFieldName.personStatusDocIssuingAuthority]}</NullValueGuard>
              </div>
            </div>
            <div className="custom-columns__col">
              <div className="custom-columns__title">Дата видачі</div>
              <div className="custom-columns__info">
                <NullValueGuard>
                  {formatDate(formData[PersonStatusFieldName.personStatusDocIssueDate] ?? '')}
                </NullValueGuard>
              </div>
            </div>
          </div>
        </div>
        <div className="custom-columns__row custom-columns__row_padding-tiny">
          <div className="custom-columns__col">
            <div className="custom-columns__title">Документ, що підтверджує статус особи</div>
            <div className="custom-columns__info">
              <NullValueGuard>
                {formData[PersonStatusFieldName.personStatusDocument] ? (
                  <PreviewFilesList files={formData[PersonStatusFieldName.personStatusDocument]} />
                ) : null}
              </NullValueGuard>
            </div>
          </div>
        </div>
      </>
    ),
  };
};
